module.exports = __webpack_public_path__ + "static/media/carismo.ef63902d.jpg";